import { useTranslation } from 'react-i18next'

import { FORMIK_SELECT_EMPTY_VALUE } from '../../../../constants/validation'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../Formik'
import { useInitiallyOpenSelect } from '../../../Select'
import { UserRoleSelect } from '../../UserRoleSelect'
import { USER_EDIT_ROLE_FIELD_NAME } from '../UserEditRoleFormModal.constants'

function UserEditRoleFormModalFields({ roleSelectOptions, typeSelectProps }) {
  const { t } = useTranslation()

  const selectStatesRef = useInitiallyOpenSelect()

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields typeSelectProps={typeSelectProps}>
        <FormikField
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={UserRoleSelect}
          controlProps={{
            contentProps: {
              placeholderProps: {
                text: t('User.SelectRoleLabelKey'),
              },
            },
          }}
          emptyValue={FORMIK_SELECT_EMPTY_VALUE}
          fieldComponentProps={{
            label: `${t('User.RoleLabelKey')}:`,
            required: true,
          }}
          getErrorProps={getFormikFormFieldErrorProps}
          name={USER_EDIT_ROLE_FIELD_NAME}
          options={roleSelectOptions}
          selectStatesRef={selectStatesRef}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default UserEditRoleFormModalFields
